import axios from 'axios'

const API_PATH = 'api/v2/admins/inventories'

export default {
  options: (id) => axios.get(`${API_PATH}/${id}/old_deal_options`),
  customers: (q) => axios.get(`${API_PATH}/old_deal_customers`, { params: { q } }),
  create: (id, old_deal) => axios.post(`${API_PATH}/${id}/create_old_deal`, { old_deal }),
  invoice: (id) => axios.post(`${API_PATH}/${id}/print_old_invoice`)
}
